import { render, staticRenderFns } from "./CustomSelect.vue?vue&type=template&id=0f832cd7&scoped=true&"
import script from "./CustomSelect.vue?vue&type=script&lang=ts&"
export * from "./CustomSelect.vue?vue&type=script&lang=ts&"
import style0 from "./CustomSelect.vue?vue&type=style&index=0&id=0f832cd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f832cd7",
  null
  
)

export default component.exports